var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNudge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.03 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#3a3a3a;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.43,40.17V44.8a4,4,0,0,0,4,4h8a4,4,0,0,0,4-4V40.17a3.94,3.94,0,0,1,1.32-3A14,14,0,0,0,40.47,25.3,14.07,14.07,0,0,0,12.4,26.71a14,14,0,0,0,4.73,10.53A3.9,3.9,0,0,1,18.43,40.17Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.47,
    y1: 32.74,
    x2: 26.47,
    y2: 48.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.5,
    y1: 26.71,
    x2: 26.47,
    y2: 32.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.44,
    y1: 26.71,
    x2: 26.47,
    y2: 32.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.66,49.11h7.62a0,0,0,0,1,0,0v5.11A3.78,3.78,0,0,1,26.49,58h-.06a3.78,3.78,0,0,1-3.78-3.78V49.11A0,0,0,0,1,22.66,49.11Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.17,
    y1: 1,
    x2: 26.17,
    y2: 7.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1,
    y1: 25.08,
    x2: 7.58,
    y2: 25.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8,
    y1: 8.49,
    x2: 12.66,
    y2: 13.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.44,
    y1: 25.08,
    x2: 52.03,
    y2: 25.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.19,
    y1: 13.14,
    x2: 45.85,
    y2: 8.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.8,
    y1: 41.67,
    x2: 10.46,
    y2: 37.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.29,
    y1: 37.02,
    x2: 46.95,
    y2: 41.67
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNudge);
export default __webpack_public_path__ + "static/media/Nudge.e5513c4b7cd9f2fcf369c1be138860e6.svg";
export { ForwardRef as ReactComponent };